import sale from './asda-sale.svg'
import priceEveryDay from './low-price-every-day.svg'

export default {
  sale,
  'price-every-day': priceEveryDay,
}



// WEBPACK FOOTER //
// ./common/components/icon/labels/index.js